export default class InvoiceRecipient {
    static fromData(data) {
        if (!data) {
            return;
        }

        const invoiceRecipient = new InvoiceRecipient();
        invoiceRecipient.id = data.id;
        invoiceRecipient.identifier = data.identifier;
        invoiceRecipient.type = data.type;
        invoiceRecipient.name = data.name;

        return invoiceRecipient;
    }

    serialize() {
        return {
            key: this.id,
        };
    }
}
